// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"34e06af3","644":"e895c504"}[chunkId] + ".chunk.js";
};